module.exports = __webpack_public_path__ + "img/announcement-icon.4c07ff2c.svg";